import React from 'react';
import { FadeIn } from './FadeIn';
export function LeadCopy() {
  return <section className="py-20 md:py-32 px-4 bg-cream-50" data-id="element-94">
      <div className="max-w-2xl mx-auto space-y-8 text-lg md:text-xl leading-relaxed text-warm-700" data-id="element-95">
        <FadeIn data-id="element-96">
          <p className="font-serif text-2xl md:text-3xl text-warm-900 mb-8" data-id="element-97">
            Llevas semanas — tal vez meses — buscando respuestas.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-98">
          <p data-id="element-99">
            Has probado champús que prometían todo. Remedios caseros que alguien
            te recomendó. Tal vez hasta fuiste al dermatólogo y saliste con más
            dudas que respuestas.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-100">
          <p data-id="element-101">
            Y mientras tanto, la picazón sigue. La descamación sigue. Esa
            sensación de que algo no está bien… sigue.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-102">
          <p className="font-medium text-sage-800" data-id="element-103">
            No estás exagerando. No es estrés. No es "solo caspa".
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-104">
          <p data-id="element-105">
            Es tu piel pidiendo calma. Y la buena noticia es que devolvérsela es
            más sencillo de lo que piensas. No necesitas más productos
            agresivos. Necesitas un método.
          </p>
        </FadeIn>
      </div>
    </section>;
}